let GearboxAuth = {};
//import { load } from 'recaptcha-v3'




import QL from "./auth.gql";


GearboxAuth.install = function(Vue, options) {
    let { $gql } = Vue;
    let authData = {};
    let notifyStore = {
        SESSION_EXIST: {
            title: "Пользователь уже авторизован",
            text: "Вы уже авторизованны",
            type: "warn"
        },
        SESSION_NOT_EXIST: {
            title: "Пользователь не авторизован",
            text: "Вы не авторизованны",
            type: "warn"
        },
        LOGIN_OR_PASSWORD_WRONG: {
            title: "Неверный логин или пароль",
            text: "Проверьте данные для входа",
            type: "error"
        },
        BAD_LOGIN: {
            title: "Неверный логин",
            text: "Проверьте правильность ввода логина",
            type: "error"
        },
        LOGIN_NOT_ENTERED: {
            title: "Ошибка",
            text: "Не введен логин",
            type: "error"
        },
        PASSWORD_NOT_ENTERED: {
            title: "Ошибка",
            text: "Не введен пароль",
            type: "error"
        },
        PASSWORD_RETYPE_WRONG: {
            title: "Ошибка",
            text: "Введенные пароли не совпадают",
            type: "error"
        },
        SIGNIN_SUCCESS: {
            title: "Добро пожаловать",
            text: "Вы успешно авторизованны",
            type: "success"
        },
        SIGNOUT_SUCCESS: {
            title: "До встречи!",
            text: "Вы успешно вышли из системы",
            type: "info"
        },
        LOGIN_IS_BUSY: {
            title: "Данная учетная записть занята",
            text: "Используйте другой логин либо авторизируйтесь",
            type: "error"
        },
        SIGNUP_SUCCESS: {
            title: "Завершите регистрацию",
            text: "Мы отправили вам код подтверждения, введите его",
            type: "info"
        },
        INVALID_SECURITY_CODE: {
            title: "Неверный код",
            text: "Проверьте правильность ввода кода",
            type: "error"
        },
        PASSWORD_RESET_SUCCESS: {
            title: "Мы отправили код",
            text: "Чтобы сбросить пароль, введите код из сообщения",
            type: "info"
        },
        PASSWORD_SET_SUCCESS: {
            title: "Ваш пароль обновлен",
            text: "Можете использовать его для входа",
            type: "success"
        }
    };

    let notify = (code) => {
        _i.bus.$emit("notify", notifyStore[code] ? notifyStore[code] : {
            title: "Неизвестная ошибка",
            text: code,
            type: "error"
        });
    };

    Vue.directive('gbx-auth', {
        bind(el, binding, vnode, oldVnode) {
            let { context } = vnode;
            setTimeout(async () => {
                console.log(context.$store)
                if (context.$store && !context.$store.state.auth) {
                    context.$store.registerModule('auth', {
                        state: {
                            auth_success: false,
                            user: false
                        },
                        mutations: {
                            authFailed(state) {
                                state.auth_success = false;
                            },
                            authSuccess(state, user) {
                                state.auth_success = true;
                                state.user = user;
                            }
                        },
                        actions: {
                            async signOut(state) {
                                await $gql.set(QL.signOut);
                        notify("SIGNOUT_SUCCESS");

                            }
                        }
                    });

                    let resCS = await $gql.get(QL.checkSession, {});
                    if (resCS.checkSession && resCS.checkSession.user) {
                        notify("SIGNIN_SUCCESS");

                        if (context.$store) context.$store.commit('authSuccess', resCS.checkSession.user);
                    }
                }
            }, 100)



            switch (binding.value) {
                case 'login-input':
                    if (localStorage.login) {
                        el.value = localStorage.login;
                        authData.login = el.value;
                    }
                    el.placeholder = 'Введите телефон или email';

                    el.addEventListener('change', (e) => {
                        authData.login = e.target.value;
                        localStorage.login = authData.login;
                    });

                    break;


                case 'password-input':
                    if (localStorage.password) {
                        el.value = localStorage.password;
                        authData.password = el.value;
                    }
                    el.placeholder = 'Введите пароль';
                    el.addEventListener('change', (e) => {
                        authData.password = e.target.value;
                        localStorage.password = authData.password;
                    });
                    break;


                case 'password-input-retype':
                    el.placeholder = 'Введите пароль еще раз';
                    el.addEventListener('change', (e) => {
                        authData.passwordRetype = e.target.value;
                    });
                    break;

                case 'sign-in-btn':
                    el.addEventListener('click', async (e) => {
                        if (!authData.login) return notify("LOGIN_NOT_ENTERED");
                        if (!authData.password) return notify("PASSWORD_NOT_ENTERED");

                        let response = await $gql.set(QL.signIn, authData);

                        if (response.errors) return notify(response.errors[0]);

                        let authPayload = response.signIn;

                        if (authPayload.user && authPayload.user._id) {
                            notify("SIGNIN_SUCCESS");
                            if (context.$store) context.$store.commit('authSuccess', authPayload.user);
                        }

                    });
                    break;


                case 'sign-up-btn':
                    el.addEventListener('click', async (e) => {

                        if (!authData.login) return notify("LOGIN_NOT_ENTERED");
                        if (!authData.password) return notify("PASSWORD_NOT_ENTERED");
                        if (authData.password != authData.passwordRetype) return notify("PASSWORD_RETYPE_WRONG");


                        let response = await $gql.set(QL.signUp, authData);
                        if (response.errors) return notify(response.errors[0]);

                        notify("SIGNUP_SUCCESS");

                        _i.bus.$emit("prompt", {
                            title: 'Введите код подтверждения',
                            placeholder: "Код из сообщения",
                            closeOnDone: false,
                            text: "Мы отправили вам код подтверждения. Введите его чтобы завершить регистрацию",
                            async cb(code) {
                                let res = await $gql.set(QL.signUpConfirm, { login: authData.login, code: parseInt(code) });

                                if (res.errors) return notify(res.errors[0]);

                                let authPayload = res.signUpConfirm;

                                if (authPayload.user && authPayload.user._id) {
                                    notify("SIGNIN_SUCCESS");
                                    if (context.$store) context.$store.commit('authSuccess', authPayload.user);
                                    _i.bus.$emit("prompt-close");
                                }


                            }
                        });


                    });
                    break;


                case 'password-reset-btn':
                    el.addEventListener('click', async (e) => {


                        if (!authData.login) return notify("LOGIN_NOT_ENTERED");
                        if (!authData.password) return notify("PASSWORD_NOT_ENTERED");
                        if (authData.password != authData.passwordRetype) return notify("PASSWORD_RETYPE_WRONG");


                        let response = await $gql.set(QL.passwordReset, authData);
                        if (response.errors) return notify(response.errors[0]);

                        notify("PASSWORD_RESET_SUCCESS");

                        _i.bus.$emit("prompt", {
                            title: 'Введите код подтверждения',
                            placeholder: "Код из сообщения",
                            closeOnDone: false,
                            text: "Мы отправили вам код для смены пароля. Введите его чтобы изменить пароль",
                            async cb(code) {
                                let res = await $gql.set(QL.passwordSet, { login: authData.login, password: authData.password, code: parseInt(code) });

                                if (res.errors) return notify(res.errors[0]);

                                notify("PASSWORD_SET_SUCCESS");
                                _i.bus.$emit("prompt-close");


                            }
                        });


                    });
                    break;


                case 'sign-out-btn':
                    el.addEventListener('click', async (e) => {

                        let response = await $gql.set(QL.signOut);

                        if (response.errors) return notify(response.errors[0]);

                        notify("SIGNOUT_SUCCESS");
                    });
                    break;
                default:
                    // statements_def
                    break;
            }
        }

    });

}

export default GearboxAuth;